<template>
  <el-container class="container gj-layout-min-width" :class="{container_vertical: navState === 'vertical'}">
<!--    <span @click="aaa">aaa</span>-->
    <template v-if="navState === 'horizontal'">
      <!-- 横向nav -->
      <el-header height="unset" class="nav-bar">
        <app-nav-bar ref="appNavBar" @cutNavState="cutNavState"></app-nav-bar>
        <app-tab-bar @cutNavState="cutNavState" ref="AppTabBar" :nav-state="navState"></app-tab-bar>
      </el-header>
      <!-- 横向main -->
      <el-main class="content horizontal" :class="{'is-dashboard': noPadding}">
        <template v-if="token">
          <keep-alive :include="keepAliveViews">
            <router-view v-if="permitted" :marketShowVideo="marketShowVideo"></router-view>
            <template v-else>
              <app-error-401></app-error-401>
            </template>
          </keep-alive>

          <div :class="{'global_guide': true}" v-if="isNewUserTask && !guideVisible && !isShowNoviceGuide"
            @click="openNoviceGuide()" @mouseenter="isShowDeleteIcon=true" @mouseleave="isShowDeleteIcon=false">
            <span class="paragraph">
              新手<br>任务
                <i class="el-icon-error" @click.stop="openDeleteNovice()" v-show="isShowDeleteIcon"></i>
            </span>
          </div>

          <!-- <transition name="QR">
            <div class="global-QR-code" v-if="showQR&&workWX==='show'">
              <div class="global-QR-code-close flex align-center justify-center" @click="showQR=!showQR">
                <i class="iconfont iconguanbi-da size12"></i>
              </div>
              <div class="global-QR-code-header size14 flex align-center justify-center">专属客服经理<br>为您服务</div>
              <div style="padding: 20px 20px 0;">
                <div class="flex align-center" style="flex-wrap: wrap;">
                  <el-image
                    :src="require('@/assets/images/QRcode/wm.png?v=1.0.0')"
                    class="global-QR-code-img"
                    style="margin-bottom: 20px;"
                  ></el-image>
                  <el-image
                    :src="require('@/assets/images/QRcode/qr.png?v=1.2.2')"
                    class="global-QR-code-img"
                  ></el-image>
                </div>
                <div class="flex justify-center align-center" style="height: 38px;">
                  <div class="unQR size12" @click="noQR">不再提示</div>
                </div>
              </div>
            </div>
          </transition> -->

          <transition name="QR">
            <div class="relate-us" v-if="!showQR&&workWX==='show'">
              <div class="icon" @click="showQR=!showQR">
                <gj-icon class="el-icon-service"></gj-icon>
              </div>
            </div>
          </transition>


<!--          <div id="global_kefu" class="relate-us">-->
<!--            <div class="icon">-->
<!--              <gj-icon class="el-icon-service"></gj-icon>-->
<!--            </div>-->
<!--            <div class="kefu">在线客服</div>-->
<!--          </div>-->
        </template>
      </el-main>
    </template>
    <template v-else>
      <!-- 纵向nav -->
      <el-aside width="60px" class="nav-bar-vertical">
        <app-nav-bar-vertical ref="appNavBarVertical"></app-nav-bar-vertical>
      </el-aside>
      <!-- 纵向main -->
      <el-container>
        <el-header height="unset" class="nav-bar">
          <app-tab-bar @cutNavState="cutNavState" ref="AppTabBar" :nav-state="navState"></app-tab-bar>
        </el-header>
        <el-main class="content vertical" :class="{'is-dashboard': noPadding}">
          <template v-if="token">

            <keep-alive :include="keepAliveViews">
              <router-view v-if="permitted"></router-view>
              <template v-else>
                <app-error-401></app-error-401>
              </template>
            </keep-alive>

            <div :class="{'global_guide': true}" v-if="isNewUserTask && !guideVisible && !isShowNoviceGuide"
                 @click="openNoviceGuide()" @mouseenter="isShowDeleteIcon=true" @mouseleave="isShowDeleteIcon=false">
                 <span class="paragraph">
                新手<br>任务
                 <i class="el-icon-error" @click.stop="openDeleteNovice()" v-show="isShowDeleteIcon"></i>
              </span>
            </div>

            <!-- <transition name="QR">
              <div class="global-QR-code" v-if="showQR&&workWX==='show'">
                <div class="global-QR-code-close flex align-center justify-center" @click="showQR=!showQR">
                  <i class="iconfont iconguanbi-da size12"></i>
                </div>
                <div class="global-QR-code-header size14 flex align-center justify-center">专属客服经理<br>为您服务</div>
                <div style="padding: 20px 20px 0;">
                  <div class="flex align-center" style="flex-wrap: wrap;">
                    <el-image
                        :src="require('@/assets/images/QRcode/wm.png?v=1.0.0')"
                        class="global-QR-code-img"
                        style="margin-bottom: 20px;"
                    ></el-image>
                    <el-image
                        :src="require('@/assets/images/QRcode/qr.png?v=1.2.2')"
                        class="global-QR-code-img"
                    ></el-image>
                  </div>
                  <div class="flex justify-center align-center" style="height: 38px;">
                    <div class="unQR size12" @click="noQR">不再提示</div>
                  </div>
                </div>
              </div>
            </transition> -->

            <transition name="QR">
              <div class="relate-us" v-if="!showQR&&workWX==='show'">
                <div class="icon" @click="showQR=!showQR">
                  <gj-icon class="el-icon-service"></gj-icon>
                </div>
              </div>
            </transition>

<!--            <div id="global_kefu" class="relate-us">-->
<!--              <div class="icon">-->
<!--                <gj-icon class="el-icon-service"></gj-icon>-->
<!--              </div>-->
<!--              <div class="kefu">在线客服</div>-->
<!--            </div>-->

          </template>
        </el-main>
      </el-container>
    </template>
    <!--    <gj-button @click="changeStatus">改变状态</gj-button>-->

    <!--  消息提醒弹框  -->
    <!--    <transition name="animation">-->
    <transition :name="transitionName">
      <div class="message-dialog" :class="parseInt(messageData.totalNum) > 0 ? 'has-shadow' : 'message-shadow'" v-if="messageData" @click="changeStatus">
        <gj-area-title>{{ messageData.warnTitleName }}</gj-area-title>
        <div class="message-content-inner text-ellipsis-2">{{currentContent}}</div>

        <div class="message-total-tooltip" v-if="parseInt(messageData.totalNum) > 0">
          余下{{ messageData.totalNum }}条未读预警
        </div>

        <div class="message-footer">
          <gj-button type="text" style="color: #666666" @click="updatePushStatus">我知道了</gj-button>
          <gj-button type="primary" class="message-query-btn" @click="viewNow">立即查看</gj-button>
        </div>
      </div>
    </transition>
    <!-- 客服按钮 -->
    <Kefu  v-if="showKefuBtn"/>
    <!--    收缩按钮，暂不实现-->
    <div class="operator-message" v-if="false" @click="changeIconType">
      <gj-icon :class="isOpen ? 'el-icon-arrow-right' : 'el-icon-arrow-left'"></gj-icon>
    </div>
    <!--    </transition>-->
    <!-- Dashboard版本公告引导 -->
    <home-guide ref="homeGuide" :visible.sync="isShowHomeGuide" @homeGuideCancel="showGuideVideo($event)"></home-guide>
  </el-container>
</template>

<script>
import AppNavBar from "./app-nav-bar/app-nav-bar.vue";
import appNavBarVertical from "./app-nav-bar/app-nav-bar-vertical.vue";
import {mapGetters} from "vuex";
import AppGiftPackageModal from "./components/modal/gift-package/gift-package-modal";
import AppWarningModal from './components/modal/remind/warning-modal'
import AppPasswordExpired from './components/modal/password-expired/password-expired'
import {editUserConfig, getLoginMsg} from "../../api/user";
import {isMeaningful} from "../../utils/common";
import AppError401 from "../modules/error/401/401";
import {isMeaninglessMixin, keepAliveMixin, kefuMixin} from "../../minxins";
import AppVersionAnnouncement from '../../views/modules/common/message/modal/version-announcement';
import AppTabBar from './app-nav-bar/app-tab-bar.vue'
import NoviceGuide from '@/views/modules/home/novice-guide/novice-guide'
//nrnf邮件公告
import NRNFNotice from '@/views/modules/home/NRNFNotice/nrnf-notice'
// 消息中心提示弹框
import MessageCenter from './components/modal/message-center/message-center'
//Dashboard版本公告引导
import HomeGuide from './components/modal/home-guide/home-guide';
import {getVersionBoot} from "@/api/message";
import DeletePrompt from './components/modal/delete-prompt/delete-prompt';
import Cookies from "js-cookie";
import { getTaskTenant } from "@/api/guide";
import {USER_GET_POLLING} from "@/store/action-types";
import { getOperationMessage, getPushList, updatePushStatus} from "@/api/warning";
import { USER_SET_MESSAGE } from "@/store/mutation-types";
import { SET_IS_NEW_USER_TASK, SET_GUIDE_VISIBLE, SET_IS_SHOW_NOVICE_GUIDE } from "@/store/mutation-types";

import {WARN_CHANGE_TITLE} from "@/utils/condition";
import {getAllMap} from "@/api/dashboard";
import {getTenantOrderDetailed} from "@/api/user";

import Kefu from '../components/kefu/ysf'

export default {
  name: "app-layout",
  mixins: [isMeaninglessMixin, keepAliveMixin, kefuMixin],
  components: {AppError401, AppNavBar, appNavBarVertical, AppTabBar, HomeGuide,Kefu},
  computed: {
    ...mapGetters(['token', 'firstLogin','userInfo', 'isPolling']),
    permitted() {
      const permissionCode = this.permissionCode;
      const condition = this.permissionCondition || 'all';
      return this.isMeaningless(permissionCode) || !this.useLoadResources || this.$permission(permissionCode, condition);
    },
    permissionCode() {
      const moduleRoute = this.$route.matched[0];
      if (moduleRoute) {
        return moduleRoute.meta.permission;
      }
      return null;
    },
    permissionCondition() {
      const moduleRoute = this.$route.matched[0];
      if (moduleRoute) {
        return moduleRoute.meta.condition;
      }
      return null;
    },
    noPadding() {
      return this.noPaddingPath.indexOf(this.$route.path) > -1
    },

    hasDashboardView(){
      return this.$permission('dashboard:view')
    }
  },

  watch: {
    isPolling(newValue) { // 是否开启轮询
      if (newValue && !this.timer) {
        this.getPushMessage();
        this.timer = setInterval(() => {
          this.getPushMessage();
        }, 1000*60*2)
      } else if (!newValue && this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    hasDashboardView:{
      handler(){
        //显示强制公共弹窗
        this.getLogsOpen()
        Promise.all([this.p2]).then(res => {
          if(this.$permission('dashboard:view')){
            // let blockUpTypes = ['ORDER_RUNNING_LOW', 'ORDER_USER_UP', 'ACCOUNT_DEACTIVATION']
            if (isMeaningful(res[0])&&res[0].type!=='ACCOUNT_DEACTIVATION'||!res[0]) {
              getVersionBoot().then((data) => {
                if (data && data.status) {
                  this.$refs.homeGuide.openNotice(data);
                } else {
                  this.openVersionNotice()
                }
              })
            }
            else {
              this.openVersionNotice()
            }
          }else {
            this.openVersionNotice()
          }
        })
      },
      immediate: true
    }
  },

  provide() {
    return {
      messageNewVal: (val) => {
        this.$nextTick(() => {
          this.$refs.appNavBar.$refs.infoBar.$refs.messageNewVal.sumMsgNumber = val
        })
      },
      // 当前页签
      getNavTabs: () => this.$refs.AppTabBar.navMenuTabs,
      // 关闭当前页面
      removeTab: (navName) => {
        this.$nextTick(() => {
          this.$refs.AppTabBar.removeTab(navName)
        })
      },
      // 批次删除tab页签
      removeTabList: (navList) => {
        this.$nextTick(() => {
          this.$refs.AppTabBar.removeTabList(navList)
        })
      },
      // 运营消息查看列表，有推送弹框关闭推送弹框
      handleMsgId: () => {
        if(this.messageData){
          this.updatePushStatus();
        }
      },
    }
  },

  data() {
    return {
      isShowHomeGuide:true,
      kefuLink: 'https://wp.qiye.qq.com/qidian/3009000551/111c0220507dd8ae602a2ed7c6bb6895',
      navState: '',

      workWX:'',
      // 是否有新手任务
      isNewUserTask: false,
      // 新手任务是否完成
      guideVisible: false,
      //新手指导按钮是否删除，true已删除，false未删除
      isShowNoviceGuide: true,
      p1: null,
      p2: null,
      isFirstLogin: null,
      noPaddingPath: [
        '/dashboard', '/seller-assistant',
        '/ad/sp-ad/ad-manager', '/ad/sb-ad/ad-manager', '/ad/sd-ad/ad-manager', '/ad/sb-ad-add', '/ad/sb-ad-edit', '/ad/sb-ad-details'// 广告模块
      ], // 不需要padding的页面，将path加入这个数组
      isShowDeleteIcon: false,
      // 存放要展示的单条消息
      messageData: null,
      // messageData: {marketName:'US:US',totalNum:12,warnTitleName:'FBA库存不足',warnTitleCode:'ORDER_WARN_001',warnContent:{reviewList:[[],[]],orderList:[[],[]]}, },
      // 存放所有推送消息列表
      allMessageList: [],
      isOpen: true,
      // transitionName有两种状态1为el-zoom-in-top,2为animation
      transitionName: 'el-zoom-in-top',
      //  轮询消息定时器
      timer: null,
      //  推送的所有id
      // currentPushIds: []
      currentContent: '',
      showQR: true,
      marketShowVideo:'',//强制引导通信店铺授权页
      orderNumber: 0, // 订单剩余量
      showKefuBtn: false, //是否展示客服入口按钮
    }
  },

  created() {
    // 一进入页面就判断是否需要开启轮询
    this.$store.dispatch(USER_GET_POLLING);
    // nav状态获取
    const getNavState = async () => {
      if (localStorage.getItem('NAV_STATE')) {
        this.navState = localStorage.getItem('NAV_STATE')
      }
      await getAllMap().then(data => {
        this.workWX = data?.workWX ?? 'show';
        this.isShowNoviceGuide = data?.isShowNoviceGuide === 'hide' ?? false
        this.$store.commit(SET_IS_SHOW_NOVICE_GUIDE, this.isShowNoviceGuide);
        if (!localStorage.getItem('NAV_STATE') || (data?.value !== this.navState)) {
          this.navState = data?.navConfig ?? 'horizontal';
        }
        //是否展示客服按钮
        this.showKefuBtn = data.qiYu && data.qiYu === 'show';
      }).catch(err => {
        this.navState = 'horizontal'
      })
      if (this.navState === '') {
        this.navState = 'horizontal'
      }
      localStorage.setItem('NAV_STATE', this.navState)
    }
    getNavState();
  },

  destroyed() {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    //不在显示企业微信二维码
    async noQR(){
      await editUserConfig({
        name: 'workWX',
        value: 'hide'
      }).then(res => {
        this.workWX = 'hide'
      })
    },
    //获取订单剩余量
    getOrderNumber() {
      this.p3 = getTenantOrderDetailed().then(res => {
        if(isMeaningful(res)) {
          this.orderNumber = res.usableOrder ? res.usableOrder : 0;
        }
        return res
      })
    },
    //密码过期提醒弹框
    openPasswordExpired(){
      //登录时提醒一次
      let noPE = Cookies.get('noPE');
      if(this.userInfo.passwordExpired && !noPE){
        Cookies.set('noPE', true)
        this.$gjCreate(AppPasswordExpired)
      }
    },
    getShowGuide() {
      this.p1 = getTaskTenant().then(res => {
        this.isNewUserTask = false
        this.guideVisible = false
        if(isMeaningful(res) && isMeaningful(res.taskTypeList) && res.taskTypeList.length > 0){
          this.isNewUserTask = true
          let flag = true
          res.taskTypeList.forEach(item => {
            if(item.taskStatus !== 'COMPLETED') {
              flag = false
            }
          })
          this.guideVisible = flag
        }
        this.$store.commit(SET_IS_NEW_USER_TASK, this.isNewUserTask);
        this.$store.commit(SET_GUIDE_VISIBLE, this.guideVisible);
        return res;
      })
    },
    checkOpenGuide(res) {
      if (!this.isNewUserTask || this.guideVisible) {  // 已完成新手任务
        this.openPasswordExpired();
      } else if(this.isNewUserTask && !this.guideVisible) {   // 有任务未完成
        if(this.orderNumber > 0 && this.isAutoEjectNewUserTask()) { // 订单量>0
          this.openNoviceGuide()
          this.setNewUserTaskAutoCacel()
        }
      }
    },
    //打开nrnf邮件公告
    openNRNFNotice(msgData){
      //根据产品约定的版本号 弹出特定的公告
      if(msgData.content.versionNumber === '2.1.1'){
        // this.$refs.homeGuide.openNotice(msgData.content.id);
        this.$gjCreate(NRNFNotice,{
          on:{
            close: () => {
              this.openPasswordExpired()
            }
          }
        })
      } else {
        //生成常规版本公告
        this.$gjCreate(AppVersionAnnouncement, {
          global: true,
          props: {
            data: msgData.content
          },
          on:{
            close: () => {
              this.openPasswordExpired()
            }
          }
        })
      }
    },
    //打开新手指引
    openNoviceGuide(noPass) {
      this.$gjCreate(NoviceGuide, {
        on: {
          closeOpen: (val) => {
            if (val === 'firstLogin') this.isFirstLogin = false;
            if(!noPass){
              this.openPasswordExpired()
            }
          }
        }
      })
    },
    // 打开删除新手指导提示框
    openDeleteNovice() {
      this.isShowDeleteIcon = false;
      const modal = this.$gjCreate(DeletePrompt, {
        on: {
          successDelete: async () => {
            //    删除成功后
            editUserConfig({
              name: 'isShowNoviceGuide',
              value: 'hide'
            }).then(res => {
              this.isShowNoviceGuide = true
              this.$store.commit(SET_IS_SHOW_NOVICE_GUIDE, this.isShowNoviceGuide);
            })
            modal.$gjDestroy();
          }
        }
      })
    },
    getLogsOpen() {
      this.p2 = getLoginMsg().then((data) => {
        // 店铺授权 SHOP_AUTH_EXPIRES  店铺授权 NO_DOCKING_SHOP
        // ORDER_RUNNING_LOW：订单可用余额不足   ORDER_USER_UP：订单已用完  ACCOUNT_DEACTIVATION：账号停用通知    PUBLICITY 更新公告
        // EMAIL_UP_WARNING 邮件数量不足
        if (data && data.type === 'ORDER_USER_UP' && data.content) {
          data.content.bizId = data.content.bizId ? data.content.bizId.split('-') : ['-', '-', '-']
        }
        return data;
      })
    },
    // 切换tab栏状态
    cutNavState(state) {
      // 关闭所有标签
      if (this.$refs.AppTabBar.navMenuTabs.length > 1) {
        this.$router.push('/dashboard')
        this.$refs.AppTabBar.closeAllTab()
      }
      // 修改AppTabBar的 info状态
      this.navState = state;
      // this.$refs.AppTabBar.navState = state;
    },

    // 当铃铛消息打开时，点击推送消息弹窗的任意一个地方，都需要关闭铃铛消息的
    changeStatus() {
      this.$refs.appNavBar.$refs.infoBar.$refs.messageNewVal.grandChange();
      // this.transitionName = 'el-zoom-in-top';\
    },

    //  立即查看
    viewNow() {
      // this.allMessageList=[];
      this.$router.push({path: '/message/message-center', query: {type: 'operation', id: this.messageData.msgIds}});
      this.updatePushStatus();
    },

    // 暂未做的收缩按钮
    changeIconType() {
      this.transitionName = 'animation';
      this.isOpen = !this.isOpen;
    },

    // 刷新右上角铃铛数据
    async refreshData() {
      const {data} = await getOperationMessage({model: {hasRead: false, pushPro: 1}, size: 6, current: 1});
      this.$store.commit(USER_SET_MESSAGE, {type: 'operation', value: data.total});
    },

    // 通知后端我已对推送消息进行了操作
    async updatePushStatus(){
      try{
        const { data } = await updatePushStatus(this.messageData.msgIds);
        if(data){
          this.messageData = null;
        }
      }catch(e){
        console.log(e);
      }
    },

    //  获取推送消息
    async getPushMessage() {
      try {
        const {data} = await getPushList();
        if (data) {
          this.messageData = data;
          this.initData();
          // 如果有数据，那就要触发右上角数据接口更新数据
          await this.refreshData();
        }
      } catch (e) {
        console.log(e);
      }
    },

    initData(){
     this.currentContent =  WARN_CHANGE_TITLE(this.messageData);
    },
    //强制引导与店铺授权页视频弹窗通信
    showGuideVideo(val){
      this.marketShowVideo = val;
      this.openVersionNotice()
    },

    openVersionNotice() {
      this.isFirstLogin = this.firstLogin;
      if (!this.firstLogin) {
        this.getShowGuide()
        this.getOrderNumber()
        Promise.all([this.p1, this.p2, this.p3]).then(res => {
          let guideData = res[0]; // 新手指引
          let msgData = res[1];  //  消息提醒
          if (isMeaningful(msgData) && isMeaningful(guideData)) {
            // ORDER_RUNNING_LOW：订单可用余额不足   ORDER_USER_UP：订单已用完  ACCOUNT_DEACTIVATION：账号停用通知 EMAIL_UP_WARNING：邮件数量不足
            if (msgData.type === 'ORDER_RUNNING_LOW' || msgData.type === 'ORDER_USER_UP' || msgData.type === 'ACCOUNT_DEACTIVATION' || msgData.type === 'EMAIL_UP_WARNING') {
              if (!this.isNewUserTask || this.guideVisible) { // 没有新手任务或者已完成新手任务
                this.$gjCreate(AppWarningModal, {
                  global: true,
                  props: {
                    item: msgData,
                  }
                })
              } else {
                this.$gjCreate(AppWarningModal, {
                  global: true,
                  props: {
                    item: msgData,
                  },
                  on: {
                    close: () => {
                      if(this.isNewUserTask && !this.guideVisible) {
                        if(this.orderNumber > 0 && this.isAutoEjectNewUserTask()) { // 订单量大于0
                          this.openNoviceGuide()
                          this.setNewUserTaskAutoCacel()
                        }
                      }
                    }
                  }
                })
              }
            }
            // 版本公告
            else if (msgData.type === 'PUBLICITY') {
              if (!this.isNewUserTask || this.guideVisible) { // 没有新手任务或者已完成新手任务
                this.openNRNFNotice(msgData)
              }else {
                if(this.orderNumber > 0 && this.isAutoEjectNewUserTask()) {// 订单量大于0
                  this.$gjCreate(NoviceGuide,{
                    on: {
                      closeOpen: () => {
                        this.openNRNFNotice(msgData)
                      }
                    }
                  })
                  this.setNewUserTaskAutoCacel()
                }
              }
            }
            // 其他情况
            else {
              this.checkOpenGuide(guideData);
            }
          }
          else if (isMeaningful(guideData)) {
            this.checkOpenGuide(guideData);
          }
        })
      } else {
        this.getShowGuide()
        this.getOrderNumber()
        Promise.all([this.p1, this.p3]).then(res => {
          if(this.isNewUserTask && !this.guideVisible) {
            if(this.orderNumber > 0 && this.isAutoEjectNewUserTask()) { // 订单量大于0
              this.openNoviceGuide()
              this.setNewUserTaskAutoCacel()
            }
          }
        })
      }
    },
    // 新手任自动弹出后设置本地缓存并记录失效时间(当天内只自动弹出一次)
    setNewUserTaskAutoCacel() {
      const invalidTime = new Date(new Date().toLocaleDateString()).getTime() + 86400000; //第二天0点时间
      localStorage.setItem(
        "newUserTaskAutoEjectInvalidTime",
        invalidTime
      );
    },

    // 根据本地缓存lacel判断是否自动弹出新手任务(当天内只自动弹出一次)
    isAutoEjectNewUserTask() {
      let newUserTaskAutoEjectInfo = localStorage.getItem('newUserTaskAutoEjectInvalidTime')
      if(isMeaningful(newUserTaskAutoEjectInfo)) {
        if(newUserTaskAutoEjectInfo.invalidTime - Date.now() <= 0) { // 缓存数据时间失效,弹出新手任务
          // console.log('缓存数据时间失效,弹出新手任务')
          return true
        } else {
          // console.log('今天自动弹出过新手任务')
          return false
        }
      } else {
        // console.log('没有缓存数据,弹出新手任务')
        return true
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/styles/app";
@import "../../assets/styles/variables";

/deep/ .el-main {
  padding: 0;
}

.container {
  height: 100vh;
  flex-direction: column;
}

.gj-layout-min-width {
  min-width: 1366px;
}

.container_vertical {
  flex-direction: row !important;
}

.content {
  background: $gj-page-bg;
  height: 100%;
  width: 100%;
}

.content {
  &.horizontal, &.vertical {
    padding: 12px 16px 16px 16px;
  }
}

.is-dashboard {
  &.horizontal, &.vertical {
    padding: 0;
  }
}

.nav-bar {
  padding: 0;
}

.relate-us {
  position: fixed;
  right: 8px;
  bottom: 70px;
  z-index: 1999;
  line-height: normal;
  border-radius: 4px;
  background: #1F6EEF;
  display: flex;
  align-items: center;
  padding: 2px;
  cursor: pointer;
}

//.relate-us:hover {
//  padding: 2px 12px 2px 2px;
//}

.relate-us .icon {
  background: #1F6EEF;
  color: #fff;
  padding: 4px;
  font-size: 25px;
  border-radius: 4px;
}

//.relate-us:hover .icon {
//  background: #fff;
//  color: #1F6EEF;
//  border-radius: 2px;
//}

.relate-us .kefu {
  display: none;
  color: #fff;
  font-size: 14px;
  line-height: 1;
  margin-left: 12px;
  transition: width 2s;
}

//.relate-us:hover .kefu {
//  display: inherit;
//}

.nav-bar-vertical {
  background: $gj-background-color-bg11;
  min-width: 60px;
  max-width: 60px;
}

.global-QR-code{
  position: fixed;
  background-color: #fff;
  width: 160px;
  right: 8px;
  bottom: 200px;
  z-index: 2000;
  border-radius: 10px 0 0 10px;
  box-shadow: 0 0 8px rgba(51, 51, 51, 0.25);
  .global-QR-code-close{
    cursor: pointer;
    position: absolute;
    right: 0;
    top:0;
    width: 20px;
    height: 20px;
    color: #fff;
    transform:scale(.7)
  }
  .global-QR-code-header{
    height: 54px;
    background: linear-gradient(0deg, #629EFF 0%, #4372E3 100%);
    color: white;
    border-radius: 10px 0 0 0;
    text-align: center;
  }
  .global-QR-code-img{
    overflow: hidden;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.25);
    border-radius: 2px;
    width: 120px;
    height: 120px;
  }
  .unQR{
    cursor: pointer;
    height: 15px;
    line-height: 15px;
    color: #D8D8D8;
    border-bottom: 1px solid #D8D8D8;
    transition: color .2s, border-color .2s;
  }
  .unQR:hover{
    color: #1F6EEF;
    border-bottom: 1px solid #1F6EEF;
  }
}

.QR-enter-active, .QR-leave-active {
  transition: opacity .3s;
}
.QR-enter, .QR-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.global_guide {
  position: fixed;
  right: 8px;
  bottom: 135px;
  z-index: 1999;
  line-height: normal;
  border-radius: 4px;
  background: #1F6EEF;
  display: flex;
  align-items: center;
  justify-content: center;
  //padding: 2px;
  cursor: pointer;
  width: 37px;
  height: 45px;

  .paragraph {
    width: 26px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    position: relative;

    /deep/ .el-icon-error {
      position: absolute;
      top: -12px;
      right: -12px;
      color: #ED6A0C;
      background: #fff;
      font-size: 14px;
      border-radius: 14px;
    }
  }
}

.first_class {
  border: 2px solid #FFFFFF;
  pointer-events: none;
}

.has-shadow{
  box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.1),
  0 -10px 0 -3px #f6f6f6,
  0 -8px 4px 0px rgba(0, 0, 0, 0.1),
  0 -20px 0 -6px #f2f2f2,
  0 -23px 10px -7px rgba(0, 0, 0, 0.1);
}

.message-shadow{
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.2);
}

.message-dialog {
  position: fixed;
  width: 320px;
  box-sizing: border-box;
  padding: 16px 24px;
  top: 100px;
  background: #fff;
  right: 30px;
  border-radius: 3px;
  z-index: 2000;
  overflow: hidden;
  max-height: 155px;

  /deep/ .el-button--text {
    padding: 0;
    line-height: 22px;
    height: 22px;
  }

  .message-total-tooltip {
    font-size: 12px;
    line-height: 18px;
    color: #1F6EEF;
  }
}

.message-content-inner {
  line-height: 18px;
  font-size: 12px;
  margin-bottom: 8px;
  word-break: break-all;
}

.message-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  margin-top: 8px;

  .message-query-btn {
    padding: 4px 16px;
  }
}

.operator-message {
  position: fixed;
  background: #1F6EEF;
  border-radius: 2px;
  padding: 4px;
  top: 150px;
  cursor: pointer;
  right: 8px;

  > i {
    color: #fff;
  }
}

.animation-enter, .animation-leave-to {
  width: 0;
  padding: 16px 0;
  //transform : translateX(390px);
  opacity: 0;
}

.animation-leave, .animation-enter-to {
  width: 360px;
  padding: 16px 24px;
  opacity: 1;
  //transform : translateX(0);
}

.animation-enter-active, .animation-leave-active {
  transition: all 0.2s
}

</style>
